import React, { useEffect, useState } from 'react';
import './ReportsView.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faChartPie, faCopy, faDashboard, faEye, faFile, faPaperPlane, faPenToSquare, faShare, faTrashCan, faUndo } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';


const config=require( '../../config.js');

const translations = {
    english: {
      name: "Name",
      company: "Company",
      email: "Email",
      category: "Category",
      language: "Language",
      year: "Year",
      filters: "Filters",
      selectLanguage: "Select Language",
      action: "Actions",
      null: "Null",
      fiscalYear: "Fiscal Year",
      status: "Status",
      report: "Report",
      third: "3rd Party",
      certificate: "Verification",
      documents: "Expert Report",
      visible: "Visible",
    },
    german: {
      name: "Name",
      company: "Unternehmen",
      email: "E-Mail",
      category: "Kategorie",
      language: "Sprache",
      year: "Jahr",
      filters: "Filter",
      selectLanguage: "Sprache wählen",
      action: "Aktionen",
      null: "Null",
      fiscalYear: "Geschäftsjahr",
      status: "Status",
      report: "Bericht",
      third: "Drittpartei",
      certificate: "Verifizierung",
      documents: "Expertenbericht",
      visible: "Sichtbar",
    },
    czech: {
      name: "Jméno",
      company: "Společnost",
      email: "E-mail",
      category: "Kategorie",
      language: "Jazyk",
      year: "Rok",
      filters: "Filtry",
      selectLanguage: "Vyberte jazyk",
      action: "Akce",
      null: "Nil",
      fiscalYear: "Hospodářský rok",
      status: "Stav",
      report: "Zpráva",
      third: "Třetí strana",
      certificate: "Ověření",
      documents: "Odborná zpráva",
      visible: "Viditelné"
  },
    italian: {
      name: "Nome",
      company: "Azienda",
      email: "Email",
      category: "Categoria",
      language: "Lingua",
      year: "Anno",
      filters: "Filtri",
      selectLanguage: "Seleziona Lingua",
      action: "Azioni",
      null: "Nullo",
      fiscalYear: "Anno Fiscale",
      status: "Stato",
      report: "Rapporto",
      third: "Terza Parte",
      certificate: "Verifica",
      documents: "Rapporto Esperto",
      visible: "Visibile",
    },
  };

function ReportsView() {
    const [Reports, setReports] = useState([]);
    const navigate = useNavigate();

    const fetchReports = async () => {
        try {
            const response = await fetch(config.env.API_BASE_URL + '/api/reports', {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                const data = await response.json();
                setReports(data);
            } else {
                console.error('Failed to fetch Reports');
            }
        } catch (error) {
            console.error('Error fetching Reports:', error);
        }
    };

    useEffect(() => {
        fetchReports(); // Fetch Reports on component mount
    }, []);

    const handleSend = async (id) => {
        try {
            const response = await fetch(config.env.API_BASE_URL+'/api/reports/' + id + '/send', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
            });

            if (response.ok) {
                alert('report sent successfully!');
                fetchReports(); // Refresh the list of Reports
            } else {
                const errorData = await response.text();
                alert(`Failed to save report: ${errorData}`);
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred while saving the report.');
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/reports/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                setReports(Reports.filter(report => report._id !== id));
                alert('report deleted successfully');
            } else {
                console.error('Failed to delete report');
            }
        } catch (error) {
            console.error('Error deleting report:', error);
        }
    };

    const getByStatus = (status) => {
        if(status == 0)
            return "Loaded";

        if(status == 1)
            return "Sent";

        if(status == 2)
            return "Assigned";

        if(status == 3)
            return "Certificated";
    }

    const GoToAssessment = (reportId) => {
        navigate(`/reports/report/view/${reportId}`);
    };

    const GoToReport = (year) => {
        navigate(`/reports?reportYear=${year}`);
    };

    const [currentLanguage] = useState(
        localStorage.getItem("language") || "english"
      );
    let lang = translations[currentLanguage];

    return (
        <>
            <div className='mt-5 Crud-main-container container'>
                <table className="table Crud-main container">
                    <thead>
                        <tr className="Crud-thead-wrapper">
                            <th scope="col">{lang.fiscalYear}</th>
                            <th scope="col">{lang.status}</th>
                            <th scope="col">{lang.report}</th>
                            <th scope="col">{lang.documents}</th>
                            <th scope="col">{lang.third}</th>
                            <th scope="col">{lang.certificate}</th>
                            <th scope="col">{lang.action}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Reports
                            .slice()
                            .map((report) => (
                                <tr key={report._id}>
                                    <td>{report.fiscalYear}</td>
                                    <td>{getByStatus(report.status)}</td>
                                    <td>
                                        <FontAwesomeIcon
                                            icon={faEye}
                                            onClick={() => {
                                                GoToAssessment(report._id);
                                            }}
                                        />
                                        <FontAwesomeIcon
                                            icon={faChartPie}
                                            style={{marginLeft: "10px"}}
                                            onClick={() => {
                                                GoToReport(report.fiscalYear);
                                            }}
                                        />
                                    </td>
                                    <td>
                                        { report.document && report.show && 
                                            <a style={{ marginLeft: "10px" }} href={config.env.STORAGE_URL + report.document} target='_blank'>
                                                <FontAwesomeIcon
                                                icon={faFile} />
                                            </a>
                                        }
                                    </td>
                                    <td>
                                        { report.thirdUserId && 
                                            <span>{report.thirdUserId.name}</span>
                                        }
                                    </td>
                                    <td>
                                        { report.certificate && report.showc && 
                                            <a style={{ marginLeft: "10px" }} href={config.env.STORAGE_URL + report.certificate} target='_blank'>
                                                <FontAwesomeIcon
                                                icon={faCertificate} />
                                            </a>
                                        }
                                    </td>
                                    <td>
                                        {
                                            report.status === 0 &&
                                        <>
                                        <FontAwesomeIcon
                                            onClick={() => {
                                                if (window.confirm('Are you sure you want to send this report?')) {
                                                    handleSend(report._id);
                                                }
                                            }}
                                            className='icon'
                                            icon={faPaperPlane}
                                        />
                                        <FontAwesomeIcon
                                            onClick={() => {
                                                if (window.confirm('Are you sure you want to send it back to the assessments section?')) {
                                                    handleDelete(report._id);
                                                }
                                            }}
                                            className='icon trash'
                                            icon={faUndo}
                                        />
                                        </>
                                    }
                                    </td>
                                </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default ReportsView;
